const PAGINATION_DOTS_TEST_ID = "paginationDots";
export {
  PAGINATION_DOTS_TEST_ID
};
